import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  progress(id) {
    return axios.get(`${this.url}/${id}/progress`);
  }
}

export default new CampaignsAPI();
